import fs from 'node:fs'
import path from 'node:path'
import { stringifyProjectJson } from '@core-engine/utils/json-format.js'
import type { InstalledPresetManifest } from '@preset-engine/types.js'

function presetsDir(cwd: string): string {
  return path.join(cwd, '.betterstart', 'presets')
}

export function presetManifestPath(cwd: string, presetId: string): string {
  return path.join(presetsDir(cwd), presetId, 'manifest.json')
}

export function loadInstalledPresetManifest(
  cwd: string,
  presetId: string
): InstalledPresetManifest | null {
  const filePath = presetManifestPath(cwd, presetId)
  if (!fs.existsSync(filePath)) {
    return null
  }

  return JSON.parse(fs.readFileSync(filePath, 'utf-8')) as InstalledPresetManifest
}

export function saveInstalledPresetManifest(cwd: string, manifest: InstalledPresetManifest): void {
  const filePath = presetManifestPath(cwd, manifest.id)
  fs.mkdirSync(path.dirname(filePath), { recursive: true })
  fs.writeFileSync(filePath, stringifyProjectJson(manifest), 'utf-8')
}

export function deleteInstalledPresetManifest(cwd: string, presetId: string): void {
  fs.rmSync(path.dirname(presetManifestPath(cwd, presetId)), {
    recursive: true,
    force: true
  })
}
